function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as StyledComps from './StyledComps';
import regionRenderers from './renderers';

var RegionRender = /*#__PURE__*/function (_Component) {
  _inherits(RegionRender, _Component);

  var _super = _createSuper(RegionRender);

  function RegionRender() {
    var _this;

    _classCallCheck(this, RegionRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "computeDebugRegionStyle", function (region) {
      var debug = _this.props.debug;
      var style = {};

      if (!debug) {
        return {};
      }

      switch (region.type) {
        case 'nav':
          style.backgroundColor = 'rgba(255,0,0,.15)';
          break;

        case 'iframe':
          style.backgroundColor = 'rgba(0,0,255,.15)';
          break;

        case 'modal':
          style.backgroundColor = 'rgba(0,255,0,.15)';
          break;

        case 'slideshow':
          style.backgroundColor = 'rgba(0,255,100,.15)';
          break;
      }

      return style;
    });

    _defineProperty(_assertThisInitialized(_this), "computeRegionStyle", function (region) {
      return Object.assign({}, {
        left: "".concat(region.x, "%"),
        top: "".concat(region.y, "%"),
        width: "".concat(region.width, "%"),
        height: "".concat(region.height, "%"),
        zIndex: "".concat(region.ZIndex + 10, "%")
      }, _this.computeDebugRegionStyle(region), _this.props.computeRegionStyle ? _this.props.computeRegionStyle(region) : {});
    });

    return _this;
  }

  _createClass(RegionRender, [{
    key: "render",
    value: function render() {
      var _extends2;

      var _this$props = this.props,
          region = _this$props.region,
          pageRef = _this$props.pageRef,
          modalRef = _this$props.modalRef,
          onPageChange = _this$props.onPageChange,
          debug = _this$props.debug,
          handleViewerEvent = _this$props.handleViewerEvent;
      var Renderer = region.type && regionRenderers[region.type] && regionRenderers[region.type].render ? regionRenderers[region.type].render : null;
      var debugOutput = region.type && regionRenderers[region.type] && regionRenderers[region.type].debug ? regionRenderers[region.type].debug : function (_ref) {
        var str = _ref.str;
        return str;
      };
      var renderProps = region.type && regionRenderers[region.type] && regionRenderers[region.type].props ? regionRenderers[region.type].props({
        region: region,
        debug: debug
      }) : {};
      return /*#__PURE__*/React.createElement(StyledComps.Region, {
        key: region['@id'],
        style: this.computeRegionStyle(region)
      }, Renderer ? /*#__PURE__*/React.createElement(Renderer, _extends((_extends2 = {
        pageRef: pageRef,
        onPageChange: onPageChange,
        region: region
      }, _defineProperty(_extends2, "pageRef", pageRef), _defineProperty(_extends2, "modalRef", modalRef), _defineProperty(_extends2, "debug", debug), _defineProperty(_extends2, "handleViewerEvent", handleViewerEvent), _extends2), renderProps)) : null, debug ? /*#__PURE__*/React.createElement(StyledComps.DebugRegion, null, debugOutput({
        str: "".concat(region['@id'], " / ").concat(region.type),
        region: region
      })) : null);
    }
  }]);

  return RegionRender;
}(Component);

RegionRender.propTypes = {
  region: PropTypes.object.isRequired,
  onPageChange: PropTypes.func.isRequired,
  computeRegionStyle: PropTypes.func,
  handleViewerEvent: PropTypes.func.isRequired,
  pageRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  modalRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })]),
  debug: PropTypes.bool
};
RegionRender.defaultProps = {
  region: null,
  onPageChange: null,
  computeRegionStyle: null,
  debug: false
};
export default RegionRender;